export enum Language {
  en = "EN",
  ru = "RU",
  // Нет переводов для всех модулей системы
  // ES = "ES",
}
